import { render, staticRenderFns } from "./194.vue?vue&type=template&id=542280d0&scoped=true&"
var script = {}
import style0 from "./194.vue?vue&type=style&index=0&id=542280d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542280d0",
  null
  
)

export default component.exports